import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { editGroup } from 'store/entities/groups/action';
import DynamicHeadTag from 'components/__new/common/DynamicHeadTag';

const EditGroupDetails = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { updateGroupLoading: loading, selectedGroup } = useSelector(state => state.entities.groups)
    const [form, setForm] = useState({});

    const updatePayload = (e) => setForm({ ...form, [e.target.name]: e.target.value })
    const returnToGroups = () => history.push('/groups')

    const updateGroupDetails = (e) => {
        e.preventDefault()
        const params = {
            autoWithdrawals: form?.autoWithdrawals === 'true' ? true : false,
            ...form,
            colorCode: "#FF3A44"
        }
        dispatch(editGroup(params, form?._id)).then(() => returnToGroups())
    }


    useEffect(() => {
        if (selectedGroup) {
            setForm(selectedGroup)
        } else {
            returnToGroups()
        }
        // eslint-disable-next-line
    }, [])

    return (
        <div>
            <DynamicHeadTag headerText="Company | Edit Group Information" headerDescription="" />
            <div onClick={returnToGroups} className="page-title flex items-center cursor-pointer">
                <FontAwesomeIcon icon="angle-left" className='mr-4' />
                Edit Group
            </div>

            <div className="w-full bg-white mt-10 p-4 lg:p-8 rounded-lg">
                <p className="mb-7 lg:mb-10 text-sm">View group policy</p>

                {loading ? <div className="table-info">
                    <FontAwesomeIcon icon="circle-notch" spin />
                    <div className="font-semibold uppercase">
                        Updating Info
                    </div>
                </div> : <form onSubmit={updateGroupDetails}>
                    <div className="w-full lg:w-2/5 space-y-8">
                        <div className="form-group">
                            <label>
                                Group Name
                                <span className="form-input-required">*</span>
                            </label>
                            <input required onChange={updatePayload} type="text" name="name" value={form?.name || ""} className="form-input" />
                        </div>

                        <div className="form-group">
                            <label>
                                Salary Auto-Withdrawal
                                <span className="form-input-required">*</span>
                            </label>
                            <select required name="autoWithdrawals" className="form-input" value={form?.autoWithdrawals?.toString() === 'true' ? "true" : "false" || ""}
                                onChange={updatePayload}>
                                {/* <option disabled value="">Select Option</option> */}
                                <option value="true">Allow Access</option>
                                <option value="false">Require Employer's Approval</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label>
                                Group Salary Withdrawal Limit
                                <span className="form-input-required">*</span>
                            </label>
                            <select required name="limit" className="form-input" value={form?.limit || ""}
                                onChange={updatePayload}>
                                {/* <option value="">Select Option</option> */}
                                <option value="50">50%</option>
                                <option value="75">75%</option>
                            </select>
                        </div>

                        <br />
                        <div className="flex items-center space-x-7">
                            <button type="submit" className="btn btn-md btn-ep-primary">
                                Save Changes
                            </button>

                            <button onClick={returnToGroups} type="button" className="btn btn-md text-ep-primary border border-ep-primary">
                                Cancel
                            </button>
                        </div>
                    </div>
                </form>}
            </div>
        </div>
    )
}

export default EditGroupDetails